import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { DollarSign, TrendingUp, Zap } from "lucide-react";
import { Card } from "@libs/rubick";
import { getCurrencySymbol } from "@/utils/formatters";
export const UsagePlanOverview = ({ usagePlan })=>{
    return /*#__PURE__*/ _jsx(Card, {
        variant: "bordered",
        title: `Current Usage Plan: ${usagePlan.name}`,
        header: /*#__PURE__*/ _jsx("p", {
            className: "text-sm text-gray-500",
            children: usagePlan.product
        }),
        children: /*#__PURE__*/ _jsxs("div", {
            className: "grid grid-cols-1 gap-6 md:grid-cols-3",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "flex items-center",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "flex-shrink-0",
                            children: /*#__PURE__*/ _jsx("div", {
                                className: "rounded-md bg-blue-50 p-3",
                                children: /*#__PURE__*/ _jsx(DollarSign, {
                                    className: "h-6 w-6 text-blue-600"
                                })
                            })
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "ml-4",
                            children: [
                                /*#__PURE__*/ _jsx("p", {
                                    className: "text-sm font-medium text-gray-500",
                                    children: "Usage Tiers"
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "space-y-1",
                                    children: usagePlan.marketplaceQuota ? /*#__PURE__*/ _jsxs("div", {
                                        className: "text-xs text-gray-900",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "mb-1 font-medium",
                                                children: "AWS Marketplace Contract"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "text-gray-600",
                                                children: "Contact AWS Marketplace for pricing details"
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "mt-1 text-gray-500",
                                                children: [
                                                    "(",
                                                    usagePlan.marketplaceQuota.includedQuotaValue,
                                                    " ",
                                                    " ",
                                                    usagePlan.marketplaceQuota.includedQuotaUnit,
                                                    " included)"
                                                ]
                                            })
                                        ]
                                    }) : usagePlan.tieredPricing ? usagePlan.tieredPricing.map((tier, index)=>/*#__PURE__*/ _jsxs("div", {
                                            className: "text-xs text-gray-900",
                                            children: [
                                                /*#__PURE__*/ _jsxs("span", {
                                                    className: "font-medium",
                                                    children: [
                                                        tier.tier,
                                                        ":"
                                                    ]
                                                }),
                                                tier.price !== undefined && /*#__PURE__*/ _jsxs(_Fragment, {
                                                    children: [
                                                        " ",
                                                        getCurrencySymbol(usagePlan.currency || "USD"),
                                                        tier.price,
                                                        "/mo"
                                                    ]
                                                }),
                                                tier.range && /*#__PURE__*/ _jsxs("span", {
                                                    className: "ml-1 text-gray-500",
                                                    children: [
                                                        "(",
                                                        tier.range,
                                                        ")"
                                                    ]
                                                })
                                            ]
                                        }, index)) : usagePlan.fixedMonthlyPrice !== undefined ? /*#__PURE__*/ _jsxs("p", {
                                        className: "text-lg font-semibold text-gray-900",
                                        children: [
                                            getCurrencySymbol(usagePlan.currency || "USD"),
                                            usagePlan.fixedMonthlyPrice,
                                            "/month"
                                        ]
                                    }) : /*#__PURE__*/ _jsx("p", {
                                        className: "text-sm text-gray-500",
                                        children: "No tiers available"
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "flex items-center",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "flex-shrink-0",
                            children: /*#__PURE__*/ _jsx("div", {
                                className: "rounded-md bg-green-50 p-3",
                                children: /*#__PURE__*/ _jsx(TrendingUp, {
                                    className: "h-6 w-6 text-green-600"
                                })
                            })
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "ml-4",
                            children: [
                                /*#__PURE__*/ _jsx("p", {
                                    className: "text-sm font-medium text-gray-500",
                                    children: "Rate Limit"
                                }),
                                /*#__PURE__*/ _jsxs("p", {
                                    className: "text-lg font-semibold text-gray-900",
                                    children: [
                                        usagePlan.rateLimit,
                                        " calls/sec"
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "flex items-center",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "flex-shrink-0",
                            children: /*#__PURE__*/ _jsx("div", {
                                className: "rounded-md bg-purple-50 p-3",
                                children: /*#__PURE__*/ _jsx(Zap, {
                                    className: "h-6 w-6 text-purple-600"
                                })
                            })
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "ml-4",
                            children: [
                                /*#__PURE__*/ _jsx("p", {
                                    className: "text-sm font-medium text-gray-500",
                                    children: "Burst Limit"
                                }),
                                /*#__PURE__*/ _jsxs("p", {
                                    className: "text-lg font-semibold text-gray-900",
                                    children: [
                                        usagePlan.burstLimit,
                                        " calls"
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
